(function () {
    /** @ngInject */
    function BookingService($http, Utils) {
        var service = this;
        this.mealid = 0;
        this.amount = 2;
        this.children_amount = null;
        this.seating_length = 0;
        this.date = null;
        this.time = null;
        this.firstname = '', this.lastname = '', this.email = '', this.phone = '', this.mobile = '';
        this.comment = '';
        this.meal = {};
        this.saveinfo = 1;
        this.giftcard = false;
        this.country_code = '+46';
        this.city = '';
        this.errors = {};
        this.cancellationEmail = false;
        this.isl = 'n';
        this.ol = '';
        this.waitlist = 0;
        this.prod_lang = {};
        this.waitlist_end = null;
        this.invitations = false;
        this.segment = '';
        this.products = [];
        this.active_invitee = {};
        this.label = '';
        this.invitations = [];
        this.mc_code = '';
        this.confirm_date = null;
        this.blocked_amounts = [];
        this.no_show_text = '';
        this.short_code = '';
        this.delivery_address = '';
        this.menu_products = [];
        this.booking_products = [];
        this.additional_requests = [];
        //this.accept_terms = false;
        this.id = 0;
        this.last_timelist = [];
        this.waitlist_full = [];
        this.custom_request = false;
        this.last_timelist_full = [];
        this.payinwidget = false;
        this.meal_type = '';
        this.temp_booking_id = 0;
        this.linked_meal = false;
        this.linked_meal_selected = false;
        this.linked_meals = [];
        this._edit = { step: '', status: false };
        this.terms = {
            general: true,
            restaurant: def_terms,
            bokabord: false
        };
        this.statistic_id = 0;

        service.getDate = function (format) {
            return moment.tgz(this.date).format(format);
        };
        service.waitlistFull = function (time) {
            return _.includes(this.waitlist_full, time);
        };
        service.checkForLinkedMeals = function () {
            this.linked_meal = false;
            this.linked_meal_selected = false;
            if (!_.has(settings, 'linked_meals')) return false;
            var linkFound = _.find(settings['linked_meals'], { meal_id: this.meal.id });
            if (linkFound) {
                this.linked_meal = _.find(meals, { id: linkFound['linked_meal_id'] });
                if (this.linked_meal) {
                    this.linked_meal['linked_meal_id'] = linkFound['linked_meal_id'];
                    this.linked_meal['meal_id'] = this.linked_meal.id;
                    return true;
                }
            }
            return false;
        };
        service.linkedMealOpt = function () {
            return this.linked_meal && this.time;
        };
        service.removeWaitlist = function(){
            if(settings && settings.waitb_id > 0 && confirm("Are you sure you want to remove this booking from the waitlist?"))
                $http.post("/reservation/api/booking/cancelReservation", {bookingid : settings.waitb_id, hash : hash}).then(function(response){
                    alert(response.data.msg);
                    window.location.href = window.location.href
                        .replace(/&waitb=[^&]+/g, '');
                });
        };
        service.hasLinkedMealSelected = function(){
          var lm = _.find(this.linked_meals, {time : ''});
          return lm && lm.id > 0 ? true : false;
        };
        service.selectedLinkedMeal = function(lm){
          this.linked_meal = lm;
          //this.linked_meal_selected = lm;
        };
        service.isLoggedIn = function(){
            return auth && auth !== false && auth.email;
        };
        service.setLinkedMeal = function (time) {
            var _lw = _.find(this.linked_meals, {id : this.linked_meal.id});
            if(_lw){
                _lw.time = time;

            }
            //this.linked_meal_selected = this.linked_meal;
            //this.linked_meal_selected['time'] = time;
        };
        service.hasLinkedMeal = function(id){
          return _.find(this.linked_meals, {id : id});
        };
        service.linkedMealAmountUp = function(){
            var lm = _.find(this.linked_meals, {id : this.linked_meal.id});
            lm.amount++;
            this.linked_meal.amount = lm.amount;
        };
        service.linkedMealAmountDown = function(){
            var lm = _.find(this.linked_meals, {id : this.linked_meal.id});
            lm.amount--;
            if(lm.amount < 1)
                lm.amount = 1;
            this.linked_meal.amount = lm.amount;
        };
        service.setDate = function (date) {
            service.date = moment.tgz(date);
        };
        service.setGiftcard = function(card){
            this.giftcard = _.extend({product : false, amount : 1}, card);
            this.meal = {id : 0, name : card.name, descr : card.description};
        }
        service.setMeal = function (meal) {
            //meal.seating.allow == true;
            this.giftcard = false;
            this.mealid = meal.id;
            this.meal = meal;
            this.seating_length = 0;
            this.seating_length = meal.allow_select_seating_time === 'Y' ? meal.length_min : 0;
            this.meal_type = meal.type;
        };
        service.getMealName = function (name) {
            //console.log(service.meal.name, name);
            var mealname = _.isUndefined(name) ? service.meal.name : name;
            if (_.size(mealname) == 0) return mealname;
            return mealname;
            var matches;
            var regex = new RegExp(language + ':(\\w{1,})', 'i');
            matches = regex.exec(mealname);
            if (_.isNull(matches)) return '';
            return matches[1];
        };
        service.printTime = function () {
            return service.time;
        };
        service.setTime = function (time, label) {
            service.label = _.isUndefined(label) || label === 'No Category' ? '' : label;
            service.time = time;
        };
        service.save = function () {
            //save guest information
            try {
                if (window.localStorage && typeof (window.localStorage) !== "undefined") {
                    var user = Object.assign({
                        firstname: "",
                        lastname: "",
                        email: "",
                        mobile: "",
                        phone: ""
                    }, service.getQuery());
                    window.localStorage.setItem("user", JSON.stringify(user));
                }
            } catch (e) {

            }
            return $http.post("/reservation/api/booking/saveBooking", service.getQuery());
        };
        service.reserveTempBooking = function () {
            var query = service.getQuery();
            query['is_temp_booking'] = true;
            query['terms'] = {
                general: true,
                restaurant: def_terms,
                bokabord: false
            };
            return $http.post("/reservation/api/booking/saveBooking", query);
        };
        service.hasHomeDelivery = function () {
            if (!settings.take_out_meals) return false;
            var products = service.getProductsList();
            if (_.size(products) <= 0) return false;
            var prdIds = _.map(products, 'ID');
            return _.find(service.booking_products, function (p) {
                return _.includes(prdIds, p.ID) && p.homedelivery == 1;
            });
        },
            service.getQuery = function () {
                return {
                    mealid: service.mealid > 0 ? service.mealid : 0,
                    firstname: service.firstname,
                    lastname: service.lastname,
                    email: service.email,
                    //phone: (service.country_code !== '+46' ? '0' + service.country_code.replace(/\+/,'') : '') + service.phone,
                    phone: service.phone,
                    isl: service.isl,
                    ol: service.ol,
                    country_code: service.country_code,
                    dial_code: service.country_code,
                    amount: service.amount > 0 ? service.amount : 2,
                    date: this.getDate('YYYY-MM-DD'),
                    offer_ID: service.meal.offer_ID || 0,
                    time: service.time,
                    bookingid: (_allow_temp ? service.temp_booking_id : 0),
                    comment: (service.hasHomeDelivery() ? service.delivery_address + "\r\n________________\r\n\n" : '') + service.comment,
                    //comment_type: service.comment_type || '',
                    waitlist: service.waitlist,
                    waitlist_end: service.waitlist_end,
                    length: service.seating_length,
                    saveinfo: service.saveinfo,
                    hd_meal: _.has(_widget_request, 'hd_meal') ? _widget_request.hd_meal : (_.has(service.meal, 'hd') ? service.meal.hd : ''),
                    ap_label: service.label,
                    testmode: testmode || 0,
                    children_amount: service.children_amount,
                    mc_code: service.mc_code || '',
                    from_url: from_url,
                    hash: hash,
                    date_code: date_code,
                    products: service.getProductsList(),
                    giftcard : service.giftcard,
                    segment: _.has(_widget_request, "segment") ? _widget_request.segment : '',
                    terms: service.terms,
                    temp_sid: settings.temp_sid,
                    waitb: settings.waitb ? settings.waitb : '',
                    linked_meals: service.linked_meals,
                    lid: settings.lid,
                    city: service.city || '',
                    widget_lang: _.has(_widget_request, "lang") ? _widget_request.lang : '',
                    important_tags: _.has(service, 'important_tags') ? service.important_tags : '',
                    is_bokabord_web: _.has(service, 'is_bokabord_web') ? service.is_bokabord_web : '',
                    statistic_id: service.statistic_id
                };
            };
        service.toggleSaveInfo = function () {
            service.saveinfo = service.saveinfo == 1 ? 0 : 1;
        };
        service.resetErrors = function () {
            service.errors = { firstname: false, lastname: false, email: false, phone: false, terms: false };
        };
        var email_regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var phone_regex = /^\(?(\+?[0-9]{1,3})\)?([0-9-\s]{1,})$/;
        service.checkGuest = function () {
            if (_.size(service.firstname) < 2) {
                service.errors.firstname = true;
                return true;
            }
            if (_.size(service.lastname) < 2) {
                service.errors.lastname = true;
                return true;
            }
            if (!email_regex.test(service.email)) {
                service.errors.email = true;
                return true;
            }
            if (_.size(service.phone) < 5 || !(phone_regex.test(service.phone))) {
                service.errors.phone = true;
                return true;
            }
            return false;
        };
        service.hasErrors = function (checkTerms) {
            service.resetErrors();
            if (!_.isUndefined(checkTerms) && service.terms.general !== true) {
                service.errors.terms = true;
                return true;
            }
            if (settings.waitb && settings.waitb.length > 0) return false;
            if (!service.giftcard && !service.mealid) return true;
            return service.checkGuest();
        };
        service.getLinkedEndTime = function (lm) {
            return this.getEndTime('',lm.time, lm.length_min);
        };
        service.getEndTime = function (prefix, _time, _length) {
            if (!settings.widget_end_time) return '';
            var length = this.seating_length;
            if (!length) length = this.meal.length_min;
            if(!_.isUndefined(_length) && _length > 0)
                length = _length;
                //length = _.isUndefined(_length) ? this.meal.length_min : _length;
            if (!length) return '';
            var time = this.time;
            if(!_.isUndefined(_time))
                time = _time;
            var m = moment.tgz(this.date);
            if (!time) return '';
            var t = time.split(':');
            if (!t || t.length != 2) return '';
            m.hours(t[0]);
            m.minutes(t[1]);
            m.add(length, 'minutes');
            prefix = _.isUndefined(prefix) ? ' - ' : '';
            return prefix + (m.format('HH:mm'));
        };
        service.sendInvitation = function (emails, message) {
            return $http.post("/reservation/api/booking/sendInvitations", { booking: service.getQuery(), emails: emails, message: message }).success(function (response) {
                if (response.success !== true) {
                    alert(response.errors);
                }
                service.invitations = true;
            });
        };
        service.initCookieData = function () {
            try {
                if (window.localStorage && typeof (window.localStorage) !== "undefined") {
                    var user = window.localStorage.getItem("user");
                    user = user ? JSON.parse(user) : false;
                }
                if(auth && auth.email){
                    user['firstname'] = auth.firstname;
                    user['lastname'] = auth.lastname;
                    user['email'] = auth.email;
                    user['phone'] = auth.mobile;
                    user['mobile'] = auth.mobile;
                }
                    _.forEach(['firstname', 'lastname', 'email', 'mobile', 'phone'], function (k) {
                        var v = user && _.has(user, k) ? user[k] : '';//Utils.getCookie(k,null);
                        if (_.has(_widget_request, k)) {
                            v = _widget_request[k];
                        }
                        if (v == '' || v == null) return;
                        if(k !== 'mobile' && k !== 'phone') {
                            service[k] = decodeURIComponent(v.toString().replace(/\+/g, ' '));
                            service[k] = decodeURIComponent(service[k]);
                        }else{
                            service[k] = v.toString();
                        }
                    });
            } catch (e) {

            }

        };
        service.initCookieData();
        /**
         *
         */
        service.printDate = function (state) {
            var _date = this.date; //moment.tgz(this.date);
            if (state == 'time') return _date.format('dddd');
            if (state == 'guest-details') return _date.format('D MMM');
            if (state == 'success') return _date.format('dddd D MMMM');
            return _date.format('D MMM');
        };
        service.hasMenu = function () {
            return _.size(this.menu_products) > 0;
        };
        service.haveMenuProduct = function () {
            return _.find(service.booking_products, { meal_type: 'Menu' });
        };
        service.groupEnabled = function () {
            if (_.has(settings, 'group_bookings') && settings.group_bookings === 'Y' && _.has(this.meal, 'group_booking') && _.size(this.meal.group_booking) > 0) {
                var service_guests = this.amount;
                return _.find(this.meal.group_booking, function (grb) {
                    return grb.min_people <= service_guests && grb.max_people >= service_guests && grb.active == 1;
                });
            }
            return false;
        };
        service.getProducts = function () {
            service.products = [];
            service.booking_products = [];
            service.menu_products = [];
            service.pairing = [];
            return $http.post("/booking-widget/api/getProducts", { hash: hash, iswl: this.waitlist, mealid: this.mealid, amount: this.amount, date: this.getDate("YYYY-MM-DD"), time: this.time, giftcard : this.giftcard ? this.giftcard.id : 0 }).success(function (response) {
                if (response.success !== true) {
                    alert(response.errors);
                } else {
                    service.prod_lang = response.lang;
                    var pairing_products = [];
                    var pairing_list = [];
                    if (_.size(response.pairing) > 0) {
                        service.pairing = response.pairing;
                        pairing_products = _.map(service.pairing, 'product_id');
                    }
                    if (_.size(response.products) > 0) {
                        _.forEach(response.products, function (product) {
                            if (product.meal_type === 'Menu') {
                                product.amount = 0;
                                service.menu_products.push(product);
                                return;
                            }
                            product.amount = 0;
                            product.is_paired = _.includes(pairing_products, product.ID);
                            product.pairing = _.map(_.filter(service.pairing, { pair_with: product.ID }), 'product_id');
                            service.products.push(product);
                        });
                    }
                }
            });
        };
        service.getPairedProducts = function (pairingIds) {
            return _.filter(service.products, function (p) {
                return _.includes(pairingIds, p.ID);
            });
        }
        service.getTotal = function () {
            var total = 0;
            if (this.products) {
                _.forEach(this.products, function (p) {
                    total += p.amount * p.meal_price;
                });
            }
            return total;
        };
        service.getProductsTotal = function () {
            var total = 0;
            if (this.booking_products) {
                _.forEach(this.booking_products, function (p) {
                    total += p.amount * p.meal_price;
                });
            }
            return total;
        };
        service.hasProducts = function () {
            return _.size(this.booking_products) > 0;
        }
        service.getProductsList = function () {
            var products = [];
            if (this.booking_products) {
                _.forEach(this.booking_products, function (p) {
                    products.push({ ID: p.ID, amount: p.amount, price: p.meal_price });
                });
            }
            return products;
        };
        service.initFromDbObj = function (book) {
            this.setDate(moment.tgz(book.date));
            for (var x in book) {
                if (x != 'date' && x != 'seating_length')
                    service[x] = book[x];
            }
        };
        service.getChildrenList = function () {
            return _.range(0, service.amount + 1);
        }
        service.getAmountsList = function (with_label) {
            var min_people = _.parseInt(this.meal.min_amount);
            var max_people = _.parseInt(this.meal.max_amount);
            if (!this.meal || this.mealid === 0) return [];
            var amounts = [];
            if (_.has(this.meal, 'group_booking') && _.size(this.meal.group_booking) > 0) {
                var maxGAmount = _.parseInt(_.max(_.map(this.meal.group_booking, 'max_people')));
                if (maxGAmount > settings.max_people) {
                    settings.max_people = maxGAmount + 2;
                    settings.max_seating = maxGAmount + 1;
                }
            }
            var max_seating = settings.max_seating && settings.max_seating > 0 ? settings.max_seating : settings.max_people;
            //console.log(max_people,this.meal,max_seating,settings.max_people, settings.max_seating);
            if (max_seating > 0) {
                for (var i = 1; i <= max_seating; i++) {
                    if (min_people > 0 && i < min_people) {

                    } else if (max_people > 0 && i > max_people) {

                    } else {
                        if (_.isUndefined(with_label))
                            amounts.push(i);
                        else
                            amounts.push({ val: i, label: i + ' ' + lang.person });
                    }
                }
            }
            return amounts;
        };
        service.cancel = function () {
            return $http.post("/reservation/api/booking/cancelReservation", { bookingid: service.id, hash: hash });
        };
        service.sendCancellationEmail = function () {
            return $http.post("/reservation/api/cancel/askForCancellation/" + service.short_code, {});
        };
        service.confirmWithCC = function (stripeResponse) {
            return $http.post("/reservation/api/booking/confirmPaymentWithCC", { booking: service.id, hash: hash, stripeResponse: stripeResponse });
        };
        service.isFullDate = function (date) {
            var off_days = _.has(service.meal, 'off_days') ? service.meal.off_days : [];
            return _.includes(off_days, date.format("YYYY-MM-DD")) || _.includes(this.blocked_amounts, date.format('YYYY-MM-DD'));
        };
        service.getStripeIntent = function (giftcard) {
            if(service.giftcard && service.giftcard.amount > 0 && service.giftcard.product){
                var guestData = {
                  firstname : service.firstname,
                  lastname : service.lastname,
                  email : service.email,
                  phone : service.phone,
                  country_code : service.country_code,
                  dial_code : service.country_code
                };
                return $http.post("/reservation/api/booking/stripeCreateIntentForGiftCard", { giftcard: service.giftcard, hash: hash, customer : guestData });
            }
            return $http.post("/reservation/api/booking/stripeCreateIntent", { booking: service.id, hash: hash, invitation: this.active_invitee, giftcard: giftcard });
        }
        service.saveStripePayment = function (paymentIntentId, purchaseId) {
            if(!_.isUndefined(purchaseId) && purchaseId > 0 && service.giftcard && service.giftcard.amount > 0 && service.giftcard.product){
                return $http.post("/reservation/api/booking/stripeHandlePayment", { purchase_id: purchaseId, hash: hash, payment_intent_id: paymentIntentId });
            }
            return $http.post("/reservation/api/booking/stripeHandlePayment", { booking: service.id, hash: hash, payment_intent_id: paymentIntentId });
        }
        service.saveStripeCard = function (paymentIntentId) {
            return $http.post("/reservation/api/booking/stripeHandlePayment", { booking: service.id, hash: hash, payment_intent_id: paymentIntentId });
        }
        service.getPendingInvitations = function () {
            var pi = _.filter(this.invitations, { confirmed: 0 });
            return pi ? pi.length : 0;
        }
        service.removeInvitation = function (invt) {
            $http.post("/reservation/api/booking/removeGroupInvitation", { booking: service.id, hash: hash, invitation: invt }).success(function (r) {
                if (r.success === true) {
                    service.invitations = r.invitations;
                } else {
                    alert(r.errors);
                }
            })
        };
        service.validateGiftCard = function (giftcard, redeemCard) {
            redeemCard = !_.isUndefined(redeemCard);
            //var arQuery = { booking: service.id, hash: hash,  redeem: redeemCard };
            //if(giftcard.type == 'voucher')
            //    arQuery['voucher_code'] = giftcard.voucher_code;
            //else
            //    arQuery['giftcard'] = giftcard.giftcard;

            return $http.post("/reservation/api/booking/validateGiftCard", { booking: service.id, hash: hash, redeem: redeemCard, giftcard: giftcard });
        };
        service.sendGroupInvitation = function (invt) {
            invt = _.merge(invt, { booking_id: service.id })
            return $http.post("/reservation/api/booking/sendGroupInvitation", { booking: service.id, hash: hash, invitation: invt }).success(function (r) {
                if (r.success === true) {
                    alertify.success(invt.email + " was invited successfully");
                    invt = { email: '' };
                    service.invitations = r.invitations;
                } else {
                    alert(r.errors);
                }
            })
        }

    }
    angular.module("Waiteraid").service("Booking", BookingService);
})();
